import { Sidebar, SidebarContent, SidebarRail } from "@/components/ui/sidebar";
import { NavGroup } from "@/components/layouts/nav-group";
import { adminSidebarData } from "./data/admin-sidebar-data";

export function AdminSidebar({
  ...props
}: React.ComponentProps<typeof Sidebar>) {
  return (
    <Sidebar collapsible="icon" variant="sidebar" {...props}>
      <SidebarContent>
        {adminSidebarData.navGroups.map((props, index) => (
          <NavGroup key={index} {...props} />
        ))}
      </SidebarContent>
      <SidebarRail />
    </Sidebar>
  );
}
